import * as appHelper from '@/components/applications/applications'

// We can further break this down to their own files if we wanted

// import actions from './actions';
// import getters from './getters';
// import mutations from './mutations';
// import state from './state';

// eslint-disable-next-line no-unused-vars
import Vue from 'vue'

const actions = {
  setSuperModel: (context, payload) => {
    context.commit('SET_SUPER_MODEL', payload)
  },
  loadCurrentApps: async (context, accountCode) => {
    try {
      const apps = await appHelper.getApplications(accountCode)
      context.commit('SET_CURRENT_APPS', apps)
    } catch (ex) {
      console.error('Failed to load apps')
    }
  },
  setCurrentApps: (context, payload) => {
    context.commit('SET_CURRENT_APPS', payload)
  },
}
const getters = {
  getSuperModel: state => state.model,
  getCurrentApps: state => state.apps,
}
const mutations = {
  SET_SUPER_MODEL: (state, payload) => {
    // Object.assign(state, payload)
    Vue.set(state, 'model', payload)
  },
  SET_CURRENT_APPS: (state, payload) => {
    if (payload == null) {
      Vue.set(state, 'apps', [])
    } else {
      Vue.set(state, 'apps', payload)
    }
  },
}
// Model would need to match `DigitalAppModel` on the backend
const state = {
  apps: [],
  model: {
    // Application Information
    linesOfBusiness: [],
    // linesOfBusinessPremiums: [],

    // Policy Buyer Information
    policyBuyerCompanyName: undefined, // AKA First named insured
    policyBuyerMailingAddressLine1: undefined,
    policyBuyerMailingAddressLine2: undefined,
    policyBuyerMailingAddressCity: undefined,
    policyBuyerMailingAddressState: undefined,
    policyBuyerMailingAddressZip: undefined,

    // TODO: Flat or objects??
    brokerName: undefined,
    brokerAddressLine1: undefined,
    brokerAddressLine2: undefined,
    brokerAddressCity: undefined,
    brokerAddressState: undefined,
    brokerAddressZip: undefined,
    brokerContactName: undefined,
    brokerContactPhone: undefined,
    brokerContactFax: undefined,
    brokerContactEmail: undefined,

    // Additional Interest
    additionalInterestInterest: undefined,
    additionalInterestName: undefined,
    additionalInterestLine1: undefined,
    additionalInterestLine2: undefined,
    additionalInterestCity: undefined,
    additionalInterestState: undefined,
    additionalInterestZip: undefined,

    // ACORD 125
    formCompletionDate: undefined,
    producerFullName: undefined,
    producerMailingAddressLineOne: undefined,
    producerMailingAddressLineTwo: undefined,
    producerMailingAddressCityName: undefined,
    producerMailingAddressStateOrProvinceCode: undefined,
    producerMailingAddressPostalCode: undefined,
    producerContactPersonFullName: undefined,
    producerContactPersonPhoneNumber: undefined,
    producerFaxNumber: undefined,
    producerContactPersonEmailAddress: undefined,
    insurerProducerIdentifier: undefined,
    insurerSubProducerIdentifier: undefined,
    insurerFullName: undefined,
    insurerNaiccode: undefined,
    insurerProductDescription: undefined,
    insurerProductCode: undefined,
    policyPolicyNumberIdentifier: undefined,
    insurerUnderwriterFullName: undefined,
    insurerUnderwriterOfficeIdentifier: undefined,
    policyStatusQuoteIndicator: undefined,
    policyStatusIssueIndicator: undefined,
    policyStatusRenewIndicator: undefined,
    policyStatusBoundIndicator: undefined,
    policyStatusChangeIndicator: undefined,
    policyStatusCancelIndicator: undefined,
    policyStatusEffectiveDate: undefined,
    policyStatusEffectiveTime: undefined,
    policyStatusEffectiveTimeAmindicator: undefined,
    policyStatusEffectiveTimePmindicator: undefined,
    policyLineOfBusinessBoilerAndMachineryIndicator: undefined,
    policyLineOfBusinessBoilerAndMachineryPremiumAmount: undefined,
    policyLineOfBusinessBusinessAutoIndicator: undefined,
    policyLineOfBusinessBusinessAutoPremiumAmount: undefined,
    policyLineOfBusinessBusinessOwnersIndicator: undefined,
    policyLineOfBusinessBusinessOwnersPremiumAmount: undefined,
    policyLineOfBusinessCommercialGeneralLiabilityIndicator: undefined,
    policyLineOfBusinessCommercialGeneralLiabilityPremiumAmount: undefined,
    policyLineOfBusinessCommercialInlandMarineIndicator: undefined,
    policyLineOfBusinessCommercialInlandMarinePremiumAmount: undefined,
    policyLineOfBusinessCommercialPropertyIndicator: undefined,
    policyLineOfBusinessCommercialPropertyPremiumAmount: undefined,
    policyLineOfBusinessCrimeIndicator: undefined,
    policyLineOfBusinessCrimePremiumAmount: undefined,
    policyLineOfBusinessCyberAndPrivacyIndicator: undefined,
    policyLineOfBusinessCyberAndPrivacyPremiumAmount: undefined,
    policyLineOfBusinessFiduciaryLiabilityIndicator: undefined,
    policyLineOfBusinessFiduciaryLiabilityPremiumAmount: undefined,
    policyLineOfBusinessGarageAndDealersIndicator: undefined,
    policyLineOfBusinessGarageAndDealersPremiumAmount: undefined,
    policyLineOfBusinessLiquorLiabilityIndicator: undefined,
    policyLineOfBusinessLiquorLiabilityPremiumAmount: undefined,
    policyLineOfBusinessMotorCarrierIndicator: undefined,
    policyLineOfBusinessMotorCarrierPremiumAmount: undefined,
    policyLineOfBusinessTruckersIndicator: undefined,
    policyLineOfBusinessTruckersPremiumAmount: undefined,
    policyLineOfBusinessUmbrellaIndicator: undefined,
    policyLineOfBusinessUmbrellaPremiumAmount: undefined,
    policyLineOfBusinessYachtIndicator: undefined,
    policyLineOfBusinessYachtPremiumAmount: undefined,
    policyLineOfBusinessOtherIndicator: undefined,
    policyLineOfBusinessOtherLineOfBusinessDescription1: undefined,
    policySectionAttachedOtherPremiumAmount1: undefined,
    policyLineOfBusinessOtherIndicator2: undefined,
    policyLineOfBusinessOtherLineOfBusinessDescription2: undefined,
    policySectionAttachedOtherPremiumAmount2: undefined,
    policyLineOfBusinessOtherIndicator3: undefined,
    policyLineOfBusinessOtherLineOfBusinessDescription3: undefined,
    policySectionAttachedOtherPremiumAmount3: undefined,
    policyLineOfBusinessOtherIndicator4: undefined,
    policyLineOfBusinessOtherLineOfBusinessDescription4: undefined,
    policySectionAttachedOtherPremiumAmount4: undefined,
    policyLineOfBusinessOtherIndicator5: undefined,
    policyLineOfBusinessOtherLineOfBusinessDescription5: undefined,
    policySectionAttachedOtherPremiumAmount5: undefined,
    policyLineOfBusinessOtherIndicator6: undefined,
    policyLineOfBusinessOtherLineOfBusinessDescription6: undefined,
    policySectionAttachedOtherPremiumAmount6: undefined,
    policySectionAttachedAccountsReceivableValuablePapersIndicator: undefined,
    attachmentAdditionalInterestScheduleIndicator: undefined,
    attachmentAdditionalPremisesScheduleIndicator: undefined,
    attachmentApartmentBuildingSupplementIndicator: undefined,
    attachmentCondominiumAssociationByLawsIndicator: undefined,
    attachmentContractorsSupplementIndicator: undefined,
    attachmentCoveragesScheduleIndicator: undefined,
    policySectionAttachedDealerIndicator: undefined,
    policySectionAttachedDriverInformationScheduleIndicator: undefined,
    policySectionAttachedElectronicDataProcessingIndicator: undefined,
    policySectionAttachedGlassAndSignIndicator: undefined,
    attachmentHotelMotelSupplementIndicator: undefined,
    policySectionAttachedInstallationBuildersRiskIndicator: undefined,
    attachmentInternationalLiabilityExposureSupplementIndicator: undefined,
    attachmentInternationalPropertyExposureSupplementIndicator: undefined,
    attachmentLossSummaryIndicator: undefined,
    policySectionAttachedOpenCargoIndicator: undefined,
    attachmentPremiumPaymentSupplementIndicator: undefined,
    attachmentProfessionalLiabilitySupplementIndicator: undefined,
    attachmentRestaurantTavernSupplementIndicator: undefined,
    attachmentStatementOfValuesIndicator: undefined,
    attachmentStateSupplementIndicator: undefined,
    attachmentVacantBuildingSupplementIndicator: undefined,
    policySectionAttachedVehicleScheduleIndicator: undefined,
    attachmentOtherIndicator: undefined,
    attachmentOtherDescription: undefined,
    attachmentOtherIndicator2: undefined,
    attachmentOtherDescription2: undefined,
    attachmentOtherIndicator3: undefined,
    attachmentOtherDescription3: undefined,
    attachmentOtherIndicator4: undefined,
    attachmentOtherDescription4: undefined,
    attachmentOtherIndicator5: undefined,
    attachmentOtherDescription5: undefined,
    attachmentOtherIndicator6: undefined,
    attachmentOtherDescription6: undefined,
    proposedPolicyEffectiveDate: undefined,
    proposedPolicyExpirationDate: undefined,
    policyPaymentDirectBillIndicator: undefined,
    policyPaymentProducerBillIndicator: undefined,
    policyPaymentPaymentScheduleCode: undefined,
    policyPaymentMethodMethodDescription: undefined,
    policyAuditFrequencyCode: undefined,
    policyPaymentDepositAmount: undefined,
    policyPaymentMinimumPremiumAmount: undefined,
    policyPaymentEstimatedTotalAmount: undefined,
    namedInsuredFullName: undefined,
    namedInsuredMailingAddressLineOne: undefined,
    namedInsuredMailingAddressLineTwo: undefined,
    namedInsuredMailingAddressCityName: undefined,
    namedInsuredMailingAddressStateOrProvinceCode: undefined,
    namedInsuredMailingAddressPostalCode: undefined,
    namedInsuredGeneralLiabilityCode: undefined,
    namedInsuredSiccode: undefined,
    namedInsuredNaicscode: undefined,
    namedInsuredTaxIdentifier: undefined,
    namedInsuredPrimaryPhoneNumber: undefined,
    namedInsuredPrimaryWebsiteAddress: undefined,
    namedInsuredLegalEntityCorporationIndicator: undefined,
    namedInsuredLegalEntityIndividualIndicator: undefined,
    namedInsuredLegalEntityJointVentureIndicator: undefined,
    namedInsuredLegalEntityLimitedLiabilityCorporationIndicator: undefined,
    namedInsuredLegalEntityMemberManagerCount: undefined,
    namedInsuredLegalEntityNotForProfitIndicator: undefined,
    namedInsuredLegalEntityPartnershipIndicator: undefined,
    namedInsuredLegalEntitySubchapterScorporationIndicator: undefined,
    namedInsuredLegalEntityTrustIndicator: undefined,
    namedInsuredLegalEntityOtherIndicator: undefined,
    namedInsuredLegalEntityOtherDescription: undefined,
    namedInsuredFullName2: undefined,
    namedInsuredMailingAddressLineOne2: undefined,
    namedInsuredMailingAddressLineTwo2: undefined,
    namedInsuredMailingAddressCityName2: undefined,
    namedInsuredMailingAddressStateOrProvinceCode2: undefined,
    namedInsuredMailingAddressPostalCode2: undefined,
    namedInsuredGeneralLiabilityCode2: undefined,
    namedInsuredSiccode2: undefined,
    namedInsuredNaicscode2: undefined,
    namedInsuredTaxIdentifier2: undefined,
    namedInsuredPrimaryPhoneNumber2: undefined,
    namedInsuredPrimaryWebsiteAddress2: undefined,
    namedInsuredLegalEntityCorporationIndicator2: undefined,
    namedInsuredLegalEntityIndividualIndicator2: undefined,
    namedInsuredLegalEntityJointVentureIndicator2: undefined,
    namedInsuredLegalEntityLimitedLiabilityCorporationIndicator2: undefined,
    namedInsuredLegalEntityMemberManagerCount2: undefined,
    namedInsuredLegalEntityNotForProfitIndicator2: undefined,
    namedInsuredLegalEntityPartnershipIndicator2: undefined,
    namedInsuredLegalEntitySubchapterScorporationIndicator2: undefined,
    namedInsuredLegalEntityTrustIndicator2: undefined,
    namedInsuredLegalEntityOtherIndicator2: undefined,
    namedInsuredLegalEntityOtherDescription2: undefined,
    namedInsuredFullName3: undefined,
    namedInsuredMailingAddressLineOne3: undefined,
    namedInsuredMailingAddressLineTwo3: undefined,
    namedInsuredMailingAddressCityName3: undefined,
    namedInsuredMailingAddressStateOrProvinceCode3: undefined,
    namedInsuredMailingAddressPostalCode3: undefined,
    namedInsuredGeneralLiabilityCode3: undefined,
    namedInsuredSiccode3: undefined,
    namedInsuredNaicscode3: undefined,
    namedInsuredTaxIdentifier3: undefined,
    namedInsuredPrimaryPhoneNumber3: undefined,
    namedInsuredPrimaryWebsiteAddress3: undefined,
    namedInsuredLegalEntityCorporationIndicator3: undefined,
    namedInsuredLegalEntityIndividualIndicator3: undefined,
    namedInsuredLegalEntityJointVentureIndicator3: undefined,
    namedInsuredLegalEntityLimitedLiabilityCorporationIndicator3: undefined,
    namedInsuredLegalEntityMemberManagerCount3: undefined,
    namedInsuredLegalEntityNotForProfitIndicator3: undefined,
    namedInsuredLegalEntityPartnershipIndicator3: undefined,
    namedInsuredLegalEntitySubchapterScorporationIndicator3: undefined,
    namedInsuredLegalEntityTrustIndicator3: undefined,
    namedInsuredLegalEntityOtherIndicator3: undefined,
    namedInsuredLegalEntityOtherDescription3: undefined,
    producerCustomerIdentifier: undefined,
    namedInsuredContactDescription: undefined,
    namedInsuredContactFullName: undefined,
    namedInsuredContactPrimaryPhoneNumber: undefined,
    namedInsuredContactPrimaryHomePhoneIndicator: undefined,
    namedInsuredContactPrimaryBusinessPhoneIndicator: undefined,
    namedInsuredContactPrimaryCellPhoneIndicator: undefined,
    namedInsuredContactSecondaryPhoneNumber: undefined,
    namedInsuredContactSecondaryHomePhoneIndicator: undefined,
    namedInsuredContactSecondaryBusinessPhoneIndicator: undefined,
    namedInsuredContactSecondaryCellPhoneIndicator: undefined,
    namedInsuredContactPrimaryEmailAddress: undefined,
    namedInsuredContactSecondaryEmailAddress: undefined,
    namedInsuredContactDescription2: undefined,
    namedInsuredContactFullName2: undefined,
    namedInsuredContactPrimaryPhoneNumber2: undefined,
    namedInsuredContactPrimaryHomePhoneIndicator2: undefined,
    namedInsuredContactPrimaryBusinessPhoneIndicator2: undefined,
    namedInsuredContactPrimaryCellPhoneIndicator2: undefined,
    namedInsuredContactSecondaryPhoneNumber2: undefined,
    namedInsuredContactSecondaryHomePhoneIndicator2: undefined,
    namedInsuredContactSecondaryBusinessPhoneIndicator2: undefined,
    namedInsuredContactSecondaryCellPhoneIndicator2: undefined,
    namedInsuredContactPrimaryEmailAddress2: undefined,
    namedInsuredContactSecondaryEmailAddress2: undefined,
    commercialStructureLocationProducerIdentifier1: undefined,
    commercialStructureBuildingProducerIdentifier1: undefined,
    commercialStructurePhysicalAddressLineOne1: undefined,
    commercialStructurePhysicalAddressLineTwo1: undefined,
    commercialStructurePhysicalAddressCityName1: undefined,
    commercialStructurePhysicalAddressCountyName1: undefined,
    commercialStructurePhysicalAddressStateOrProvinceCode1: undefined,
    commercialStructurePhysicalAddressPostalCode1: undefined,
    commercialStructureRiskLocationInsideCityLimitsIndicator1: undefined,
    commercialStructureRiskLocationOutsideCityLimitsIndicator1: undefined,
    commercialStructureRiskLocationOtherIndicator1: undefined,
    commercialStructureRiskLocationOtherDescription1: undefined,
    commercialStructureInsuredInterestOwnerIndicator1: undefined,
    commercialStructureInsuredInterestTenantIndicator1: undefined,
    commercialStructureInsuredInterestOtherIndicator1: undefined,
    commercialStructureInsuredInterestOtherDescription1: undefined,
    businessInformationFullTimeEmployeeCount1: undefined,
    businessInformationPartTimeEmployeeCount1: undefined,
    commercialStructureAnnualRevenueAmount1: undefined,
    buildingOccupancyOccupiedArea1: undefined,
    buildingOccupancyOpenToPublicArea1: undefined,
    constructionBuildingArea1: undefined,
    buildingOccupancyOperationsDescription1: undefined,
    commercialStructureQuestionAbbcode1: undefined,
    commercialStructureBuildingProducerIdentifier2: undefined,
    commercialStructurePhysicalAddressLineOne2: undefined,
    commercialStructurePhysicalAddressLineTwo2: undefined,
    commercialStructurePhysicalAddressCityName2: undefined,
    commercialStructurePhysicalAddressCountyName2: undefined,
    commercialStructurePhysicalAddressStateOrProvinceCode2: undefined,
    commercialStructurePhysicalAddressPostalCode2: undefined,
    commercialStructureRiskLocationInsideCityLimitsIndicator2: undefined,
    commercialStructureRiskLocationOutsideCityLimitsIndicator2: undefined,
    commercialStructureRiskLocationOtherIndicator2: undefined,
    commercialStructureRiskLocationOtherDescription2: undefined,
    commercialStructureInsuredInterestOwnerIndicator2: undefined,
    commercialStructureInsuredInterestTenantIndicator2: undefined,
    commercialStructureInsuredInterestOtherIndicator2: undefined,
    commercialStructureInsuredInterestOtherDescription2: undefined,
    businessInformationFullTimeEmployeeCount2: undefined,
    businessInformationPartTimeEmployeeCount2: undefined,
    commercialStructureAnnualRevenueAmount2: undefined,
    buildingOccupancyOccupiedArea2: undefined,
    buildingOccupancyOpenToPublicArea2: undefined,
    constructionBuildingArea2: undefined,
    buildingOccupancyOperationsDescription2: undefined,
    commercialStructureQuestionAbbcode2: undefined,
    commercialStructureLocationProducerIdentifier3: undefined,
    commercialStructureBuildingProducerIdentifier3: undefined,
    commercialStructurePhysicalAddressLineOne3: undefined,
    commercialStructurePhysicalAddressLineTwo3: undefined,
    commercialStructurePhysicalAddressCityName3: undefined,
    commercialStructurePhysicalAddressCountyName3: undefined,
    commercialStructurePhysicalAddressStateOrProvinceCode3: undefined,
    commercialStructurePhysicalAddressPostalCode3: undefined,
    commercialStructureRiskLocationInsideCityLimitsIndicator3: undefined,
    commercialStructureRiskLocationOutsideCityLimitsIndicator3: undefined,
    commercialStructureRiskLocationOtherIndicator3: undefined,
    commercialStructureRiskLocationOtherDescription3: undefined,
    commercialStructureInsuredInterestOwnerIndicator3: undefined,
    commercialStructureInsuredInterestTenantIndicator3: undefined,
    commercialStructureInsuredInterestOtherIndicator3: undefined,
    commercialStructureInsuredInterestOtherDescription3: undefined,
    businessInformationFullTimeEmployeeCount3: undefined,
    businessInformationPartTimeEmployeeCount3: undefined,
    commercialStructureAnnualRevenueAmount3: undefined,
    buildingOccupancyOccupiedArea3: undefined,
    buildingOccupancyOpenToPublicArea3: undefined,
    constructionBuildingArea3: undefined,
    buildingOccupancyOperationsDescription3: undefined,
    commercialStructureQuestionAbbcode3: undefined,
    commercialStructureLocationProducerIdentifier4: undefined,
    commercialStructureBuildingProducerIdentifier4: undefined,
    commercialStructurePhysicalAddressLineOne4: undefined,
    commercialStructurePhysicalAddressLineTwo4: undefined,
    commercialStructurePhysicalAddressCityName4: undefined,
    commercialStructurePhysicalAddressCountyName4: undefined,
    commercialStructurePhysicalAddressStateOrProvinceCode4: undefined,
    commercialStructurePhysicalAddressPostalCode4: undefined,
    commercialStructureRiskLocationInsideCityLimitsIndicator4: undefined,
    commercialStructureRiskLocationOutsideCityLimitsIndicator4: undefined,
    commercialStructureRiskLocationOtherIndicator4: undefined,
    commercialStructureRiskLocationOtherDescription4: undefined,
    commercialStructureInsuredInterestOwnerIndicator4: undefined,
    commercialStructureInsuredInterestTenantIndicator4: undefined,
    commercialStructureInsuredInterestOtherIndicator4: undefined,
    commercialStructureInsuredInterestOtherDescription4: undefined,
    businessInformationFullTimeEmployeeCount4: undefined,
    businessInformationPartTimeEmployeeCount4: undefined,
    commercialStructureAnnualRevenueAmount4: undefined,
    buildingOccupancyOccupiedArea4: undefined,
    buildingOccupancyOpenToPublicArea4: undefined,
    constructionBuildingArea4: undefined,
    buildingOccupancyOperationsDescription4: undefined,
    commercialStructureQuestionAbbcode4: undefined,
    businessInformationBusinessTypeApartmentsIndicator: undefined,
    businessInformationBusinessTypeCondominiumsIndicator: undefined,
    businessInformationBusinessTypeContractorIndicator: undefined,
    businessInformationBusinessTypeInstitutionalIndicator: undefined,
    businessInformationBusinessTypeManufacturingIndicator: undefined,
    businessInformationBusinessTypeOfficeIndicator: undefined,
    businessInformationBusinessTypeRestaurantIndicator: undefined,
    businessInformationBusinessTypeRetailIndicator: undefined,
    businessInformationBusinessTypeServiceIndicator: undefined,
    businessInformationBusinessTypeWholesaleIndicator: undefined,
    businessInformationBusinessTypeOtherIndicator: undefined,
    businessInformationBusinessTypeOtherDescription: undefined,
    namedInsuredBusinessStartDate: undefined,
    primaryOperationsDescription: undefined,
    commercialStructureInstallationRepairWorkPercent: undefined,
    commercialStructureInstallationRepairWorkOffPremisesPercent: undefined,
    otherOperationsDescription: undefined,
    additionalInterestInterestAdditionalInsuredIndicator: undefined,
    additionalInterestInterestBreachOfWarrantyIndicator: undefined,
    additionalInterestInterestCoOwnerIndicator: undefined,
    additionalInterestInterestEmployeeAsLessorIndicator: undefined,
    additionalInterestInterestLeasebackOwnerIndicator: undefined,
    additionalInterestInterestLendersLossPayableIndicator: undefined,
    additionalInterestInterestLienholderIndicator: undefined,
    additionalInterestInterestLossPayeeIndicator: undefined,
    additionalInterestInterestMortgageeIndicator: undefined,
    additionalInterestInterestOwnerIndicator: undefined,
    additionalInterestInterestRegistrantIndicator: undefined,
    additionalInterestInterestTrusteeIndicator: undefined,
    additionalInterestInterestOtherIndicator: undefined,
    additionalInterestInterestOtherDescription: undefined,
    additionalInterestInterestReasonDescription: undefined,
    additionalInterestInterestRank: undefined,
    additionalInterestCertificateRequiredIndicator: undefined,
    additionalInterestPolicyRequiredIndicator: undefined,
    additionalInterestSendBillIndicator: undefined,
    additionalInterestFullName: undefined,
    additionalInterestMailingAddressLineOne: undefined,
    additionalInterestMailingAddressLineTwo: undefined,
    additionalInterestMailingAddressCityName: undefined,
    additionalInterestMailingAddressStateOrProvinceCode: undefined,
    additionalInterestMailingAddressPostalCode: undefined,
    additionalInterestMailingAddressCountryCode: undefined,
    additionalInterestAccountNumberIdentifier: undefined,
    additionalInterestInterestEndDate: undefined,
    additionalInterestLoanAmount: undefined,
    additionalInterestPrimaryPhoneNumber: undefined,
    additionalInterestPrimaryFaxNumber: undefined,
    additionalInterestPrimaryEmailAddress: undefined,
    additionalInterestItemLocationProducerIdentifier: undefined,
    additionalInterestItemBuildingProducerIdentifier: undefined,
    additionalInterestItemVehicleProducerIdentifier: undefined,
    additionalInterestItemBoatProducerIdentifier: undefined,
    additionalInterestItemAirportIdentifier: undefined,
    additionalInterestItemAircraftProducerIdentifier: undefined,
    additionalInterestItemScheduledItemClassCode: undefined,
    additionalInterestItemScheduledItemProducerIdentifier: undefined,
    additionalInterestItemDescription: undefined,
    isApplicantASubsidiary: undefined,
    parentCompanyName: undefined,
    parentRelationshipDescription: undefined,
    parentOwnershipPercent: undefined,
    doesApplicantHaveSubsidiaries: undefined,
    subsidiaryOrganizationName: undefined,
    subsidiaryRelationshipDescription: undefined,
    subsidiaryOwnershipPercent: undefined,
    hasFormalSafteyProgram: undefined,
    formalSafetyProgramSafetyManualIndicator: undefined,
    formalSafetyProgramSafetyPositionIndicator: undefined,
    formalSafetyProgramOshaindicator: undefined,
    nyExposureToFlammableExplosivesChemicals: undefined,
    anyExposureToFlammableExplosivesChemicalsExplanation: undefined,
    anyOtherInsuranceWithThisCompany: undefined,
    otherPolicyLineOfBusinessCode1: undefined,
    otherPolicyPolicyNumberIdentifier1: undefined,
    otherPolicyPolicyNumberIdentifier2: undefined,
    otherPolicyLineOfBusinessCode2: undefined,
    cancelNonRenewUnderwritingConditionCorrected: undefined,
    cancelNonRenewNonPaymentIndicator: undefined,
    cancelNonRenewNonRenewalIndicator: undefined,
    cancelNonRenewAgentNoLongerWritesForInsurerIndicator: undefined,
    cancelNonRenewUnderwritingIndicator: undefined,
    cancelNonRenewUnderwritingConditionCorrectedIndicator: undefined,
    cancelNonRenewUnderwritingConditionCorrectedDescription: undefined,
    cancelNonRenewOtherIndicator: undefined,
    cancelNonRenewOtherDescription: undefined,
    pastLossesClaimsRelatingSexualAbuseDiscriminationNegligentHiring: undefined,
    pastLossesClaimsRelatingSexualAbuseDiscriminationNegligentHiringExplanation: undefined,
    pastFiveYearsAnyApplicantIndictedOrConvictedFraudBriberyArson: undefined,
    pastFiveYearsAnyApplicantIndictedOrConvictedFraudBriberyArsonExplanation: undefined,
    uncorrectedFireCodeViolationResolution: undefined,
    uncorrectedFireCodeViolationExplanation1: undefined,
    uncorrectedFireCodeViolationResolutionDescription1: undefined,
    uncorrectedFireCodeViolationResolutionDate1: undefined,
    uncorrectedFireCodeViolationOccurrenceDate2: undefined,
    uncorrectedFireCodeViolationExplanation2: undefined,
    uncorrectedFireCodeViolationResolutionDescription2: undefined,
    uncorrectedFireCodeViolationResolutionDate2: undefined,
    hadForeclosureBankruptcyLastFiveYears: undefined,
    foreclosureRepossessionBankruptcyOccurrenceDate1: undefined,
    foreclosureRepossessionBankruptcyExplanation1: undefined,
    foreclosureRepossessionBankruptcyResolutionDescription1: undefined,
    foreclosureRepossessionBankruptcyResolutionDate1: undefined,
    foreclosureRepossessionBankruptcyOccurrenceDate2: undefined,
    foreclosureRepossessionBankruptcyExplanation2: undefined,
    foreclosureRepossessionBankruptcyResolutionDescription2: undefined,
    foreclosureRepossessionBankruptcyResolutionDate2: undefined,
    judgementOrLienInLastFiveYears: undefined,
    judgementOrLienOccurrenceDate1: undefined,
    judgementOrLienExplanation1: undefined,
    judgementOrLienResolutionDescription1: undefined,
    judgementOrLienResolutionDate1: undefined,
    judgementOrLienOccurrenceDate2: undefined,
    judgementOrLienExplanation2: undefined,
    judgementOrLienResolutionDescription2: undefined,
    judgementOrLienResolutionDate2: undefined,
    questionAbbcode: undefined,
    anyForeignOperations: undefined,
    applicantOtherBusinessVenturesCoverageNotRequested: undefined,
    applicantOtherBusinessVenturesCoverageNotRequestedExplanation: undefined,
    applicantOwnLeaseOperateDrones: undefined,
    applicantOwnLeaseOperateDronesExplanation: undefined,
    applicantHireOthersOperateDrones: undefined,
    applicantHireOthersOperateDronesExplanation: undefined,
    remarkText: undefined,
    priorCoveragePolicyYear1: undefined,
    priorCoverageGeneralLiabilityInsurerFullName1: undefined,
    priorCoverageGeneralLiabilityPolicyNumberIdentifier1: undefined,
    priorCoverageGeneralLiabilityTotalPremiumAmount1: undefined,
    priorCoverageGeneralLiabilityEffectiveDate1: undefined,
    priorCoverageGeneralLiabilityExpirationDate1: undefined,
    priorCoverageAutomobileInsurerFullName1: undefined,
    priorCoverageAutomobilePolicyNumberIdentifier1: undefined,
    priorCoverageAutomobileTotalPremiumAmount1: undefined,
    priorCoverageAutomobileEffectiveDate1: undefined,
    priorCoverageAutomobileExpirationDate1: undefined,
    priorCoveragePropertyInsurerFullName1: undefined,
    priorCoveragePropertyPolicyNumberIdentifier1: undefined,
    priorCoveragePropertyTotalPremiumAmount1: undefined,
    priorCoveragePropertyEffectiveDate1: undefined,
    priorCoveragePropertyExpirationDate1: undefined,
    priorCoverageOtherLineInsurerFullName1: undefined,
    priorCoverageOtherLinePolicyNumberIdentifier1: undefined,
    priorCoverageOtherLineTotalPremiumAmount1: undefined,
    priorCoverageOtherLineEffectiveDate1: undefined,
    priorCoverageOtherLineExpirationDate1: undefined,
    priorCoveragePolicyYear2: undefined,
    priorCoverageGeneralLiabilityInsurerFullName2: undefined,
    priorCoverageGeneralLiabilityPolicyNumberIdentifier2: undefined,
    priorCoverageGeneralLiabilityTotalPremiumAmount2: undefined,
    priorCoverageGeneralLiabilityEffectiveDate2: undefined,
    priorCoverageGeneralLiabilityExpirationDate2: undefined,
    priorCoverageAutomobileInsurerFullName2: undefined,
    priorCoverageAutomobilePolicyNumberIdentifier2: undefined,
    priorCoverageAutomobileTotalPremiumAmount2: undefined,
    priorCoverageAutomobileEffectiveDate2: undefined,
    priorCoverageAutomobileExpirationDate2: undefined,
    priorCoveragePropertyInsurerFullName2: undefined,
    priorCoveragePropertyPolicyNumberIdentifier2: undefined,
    priorCoveragePropertyTotalPremiumAmount2: undefined,
    priorCoveragePropertyEffectiveDate2: undefined,
    priorCoveragePropertyExpirationDate2: undefined,
    priorCoverageOtherLineLineOfBusinessCode: undefined,
    priorCoverageOtherLineInsurerFullName2: undefined,
    priorCoverageOtherLinePolicyNumberIdentifier2: undefined,
    priorCoverageOtherLineTotalPremiumAmount2: undefined,
    priorCoverageOtherLineEffectiveDate2: undefined,
    priorCoverageOtherLineExpirationDate2: undefined,
    priorCoveragePolicyYear3: undefined,
    priorCoverageGeneralLiabilityInsurerFullName3: undefined,
    priorCoverageGeneralLiabilityPolicyNumberIdentifier3: undefined,
    priorCoverageGeneralLiabilityTotalPremiumAmount3: undefined,
    priorCoverageGeneralLiabilityEffectiveDate3: undefined,
    priorCoverageGeneralLiabilityExpirationDate3: undefined,
    priorCoverageAutomobileInsurerFullName3: undefined,
    priorCoverageAutomobilePolicyNumberIdentifier3: undefined,
    priorCoverageAutomobileTotalPremiumAmount3: undefined,
    priorCoverageAutomobileEffectiveDate3: undefined,
    priorCoverageAutomobileExpirationDate3: undefined,
    priorCoveragePropertyInsurerFullName3: undefined,
    priorCoveragePropertyPolicyNumberIdentifier3: undefined,
    priorCoveragePropertyTotalPremiumAmount3: undefined,
    priorCoveragePropertyEffectiveDate3: undefined,
    priorCoveragePropertyExpirationDate3: undefined,
    priorCoverageOtherLineInsurerFullName3: undefined,
    priorCoverageOtherLinePolicyNumberIdentifier3: undefined,
    priorCoverageOtherLineTotalPremiumAmount3: undefined,
    priorCoverageOtherLineEffectiveDate3: undefined,
    priorCoverageOtherLineExpirationDate3: undefined,
    lossHistoryNoPriorLossesIndicator: undefined,
    lossHistoryInformationYearCount: undefined,
    lossHistoryTotalAmount: undefined,
    lossHistoryOccurrenceDate1: undefined,
    lossHistoryLineOfBusiness1: undefined,
    lossHistoryOccurrenceDescription1: undefined,
    lossHistoryClaimDate1: undefined,
    lossHistoryPaidAmount1: undefined,
    lossHistoryReservedAmount1: undefined,
    lossHistoryClaimStatusSubrogationCode1: undefined,
    lossHistoryClaimStatusOpenCode1: undefined,
    lossHistoryOccurrenceDate2: undefined,
    lossHistoryLineOfBusiness2: undefined,
    lossHistoryOccurrenceDescription2: undefined,
    lossHistoryClaimDate2: undefined,
    lossHistoryPaidAmount2: undefined,
    lossHistoryReservedAmount2: undefined,
    lossHistoryClaimStatusSubrogationCode2: undefined,
    lossHistoryClaimStatusOpenCode2: undefined,
    lossHistoryOccurrenceDate3: undefined,
    lossHistoryLineOfBusiness3: undefined,
    lossHistoryOccurrenceDescription3: undefined,
    lossHistoryClaimDate3: undefined,
    lossHistoryPaidAmount3: undefined,
    lossHistoryReservedAmount3: undefined,
    lossHistoryClaimStatusSubrogationCode3: undefined,
    lossHistoryClaimStatusOpenCode3: undefined,
    policyInformationPracticesNoticeIndicator: undefined,
    namedInsuredInitials: undefined,
    producerAuthorizedRepresentativeSignature: undefined,
    producerAuthorizedRepresentativeFullName: undefined,
    producerStateLicenseIdentifier: undefined,
    namedInsuredSignature: undefined,
    namedInsuredSignatureDate: undefined,
    producerNationalIdentifier: undefined,
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
